<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Solicitar Carta De No Adeudo" description="Completa los datos que se solicitan para obtener tu Carta de no adeudo." />
      <NoDebtLetter/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import NoDebtLetter from '@/components/NoDebtCertificate/NoDebtCertificate.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {}
  },
  name: 'NoDebtLetterView',
  components: {
    NoDebtLetter,
    Header,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>